import * as React from 'react'
import { observer, inject } from 'mobx-react'
import { StateType } from '../state/state'
import { Label } from '../../../components/ui/Label'
import { Toggle } from '../../../components/ui/Toggle'

interface Props {
  className?: string
  state?: StateType
}

export const DataTypeToggles: React.FC<Props> = inject('state')(
  observer(({ className = '', state }) => {
    const {
      areSymlogScalesActive,
      toggleAreSymlogScalesActive,
      isPerCapitaActive,
      toggleIsPerCapitaActive,
    } = state.ScatterplotState

    return (
      <div className={`-data-type-toggles ${className}`}>
        <Label className="mb2" label="Data type" />
        <Toggle
          checked={isPerCapitaActive}
          onChange={toggleIsPerCapitaActive}
          labelOff={'Absolute'}
          widthOff={86}
          labelOn={'Per Capita'}
          widthOn={101}
        />
        <div className="-spacer mv2" />
        <Toggle
          checked={areSymlogScalesActive}
          onChange={toggleAreSymlogScalesActive}
          labelOff={'Linear'}
          widthOff={67}
          labelOn={'Logarithmic'}
          widthOn={111}
        />
      </div>
    )
  })
)
